import Repository from '@/repositories/repository'

const MetaTrader4Repository = {
  async getMetaTrader4Data(queryParams: any = {}) {
    const params = {
      ...queryParams
    }

    return await Repository('metatrader-4', 'page', params)
  }
}

export default MetaTrader4Repository
